import {ApiRequestor} from "@/classes/requestors/api.requestor";

export class DtoApiPostSponsorActivations extends ApiRequestor {
  async $post(params) {
    const payload = params
    return this.$http('POST', '/bookedActivity', {payload})
  }
}
